/**
 * Its a method to return a descriptor from a target and its property key
 * @param target Target to get the descriptor
 * @param propertyKey Some property for that target
 * @returns the descriptor of that property on that target
 */
export function getOwnPropertyDescriptor(
  target: any,
  propertyKey: string | symbol
) {
  return (
    Object.getOwnPropertyDescriptor(target, propertyKey) || {
      value: (target as Record<string | symbol, unknown>)[propertyKey],
      writable: true,
      enumerable: true,
      configurable: true
    }
  );
}

/**
 * Get class name for logging (handles both static and instance methods)
 * @param target Target to get the class name
 * @returns The class name as string
 */
export function getClassName(target: any): string {
  return typeof target === 'function'
    ? (target as { name?: string }).name
    : (target as { constructor?: { name?: string } })?.constructor?.name ||
        'Unknown';
}

/**
 * Utility object to expose decorator-related utilities
 */
export const decoratorUtil = {
  getOwnPropertyDescriptor: getOwnPropertyDescriptor,
  getClassName: getClassName
};
